// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import { alphaSort } from '../../../common/utils'
import { i18n } from '../../index'
import Table from '@mui/material/Table'
import TableHead from '@mui/material/TableHead'
import TableBody from '@mui/material/TableBody'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import EmployeeRow from './EmployeeRow'
import type { User } from '../users/userTypes'
import css from './employeeList.css'
type EmployeeListProps = {
  stationId: string
  data: Array<User>
}

const EmployeeList = ({ stationId, data }: EmployeeListProps) => (
  <div className={css.component}>
    {data.length ? (
      <Table>
        <TableHead>
          <TableRow className={css.tableHeadingRow}>
            <TableCell>{i18n.t('admin.user.name')}</TableCell>
            <TableCell>{i18n.t('admin.user.userType')}</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {alphaSort('name', data).map((user) => (
            <EmployeeRow stationId={stationId} data={user} key={user.id} />
          ))}
        </TableBody>
      </Table>
    ) : (
      <p className={css.empty}>{i18n.t('admin.stations.noEmployees')}</p>
    )}
  </div>
)

export default EmployeeList
